import { render, staticRenderFns } from "./Count_Details.vue?vue&type=template&id=c77f2f78&scoped=true&"
import script from "./Count_Details.vue?vue&type=script&lang=js&"
export * from "./Count_Details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c77f2f78",
  null
  
)

export default component.exports